import FileUploaderComponent from './file-uploader/file-uploader.component';
import FileUploaderService from "./services/file-uploader.service";

angular
  .module('file-uploader', [])
  .component('fileUploader', FileUploaderComponent)
  .service( 'FileUploaderService', FileUploaderService );